import { ContactFormField } from './ContactFormField';
import { FormFieldValue } from '../types';

export class ValidationResult {
  readonly isValid: boolean;
  readonly errorTags: string[];

  private constructor(isValid: boolean, errorTags: string[]) {
    this.isValid = isValid;
    this.errorTags = errorTags;
  }

  static create(isValid: boolean, errorTags?: Nullable<string[]>): ValidationResult {
    return new ValidationResult(isValid, errorTags ?? []);
  }
}

export class FormFieldValidator extends ContactFormField {
  protected readonly isRequired: boolean;

  constructor(isRequired: boolean, minLength?: Nullable<number>, maxLength?: Nullable<number>) {
    super(minLength, maxLength);
    this.isRequired = isRequired;
  }

  async validate(value: FormFieldValue = ''): Promise<ValidationResult> {
    const isValid = this.isValid(value);
    const errorTags = !isValid ? this.getErrorTags(value) : null;

    return ValidationResult.create(isValid, errorTags);
  }

  protected getErrorTags(value: FormFieldValue): string[] | undefined {
    return undefined;
  }

  protected isValid(value: FormFieldValue): boolean {
    throw new Error('This method should be implemented in child classes.');
  }

  protected requiredCheck(value: FormFieldValue): boolean {
    return this.isRequired ? !this.isEmpty(value) : true;
  }
}
